import { type AccountInfo } from '../types';
import { DEFAULT_STARGATE_SERVICE_URL } from './common';
import { fetchJson } from './helpers';

export interface AccountInfoClientInterface {
	getAccountInfo(): Promise<AccountInfo>;
}

export class AccountInfoClient implements AccountInfoClientInterface {
	public async getAccountInfo(): Promise<AccountInfo> {
		const fetchUrl = `${DEFAULT_STARGATE_SERVICE_URL}/me`;
		const resp = await fetchJson<AccountInfo>(fetchUrl, 'getAccountInfo');
		return resp;
	}
}
